<template>
  <div id="reorder" class="center-align pt-5">
    <v-progress-circular
      :size="70"
      :width="7"
      indeterminate
    ></v-progress-circular><br>
    Creating Order...
  </div>
</template>

<script>
  import api from '@/api/gungho'

  export default {
    metaInfo () {
      return {
        title: `Reorder ${this.order ? `${this.order.site_code}${this.order.id}` : ''}`
      }
    },

    computed: {
      cart: {
        get () {
          return this.$store.state.cart
        },
        set (value) {
          this.$store.commit('saveCart', value)
        }
      }
    },

    methods: {
      data () {
        return {
          orderId: false,
          order: false
        }
      },

      reorder (order) {
        if (!order || !order.items) return false

        console.log('Reordering: ', order.id)

        for (var item of order.items) {
          console.log(`Copy item, ${item.id}, to cart`)
          this.$store.dispatch('addCartItem', {
            'order_item_id': item.id,
            'project_id': item.project_id,
            'quantity': item.quantity
          })
        }

        if (order.shipping_info) {
          if (!this.cart.shipping_address) this.cart.shipping_address = {}
          this.cart.shipping_address.first_name = order.shipping_info.first_name
          this.cart.shipping_address.last_name = order.shipping_info.last_name
          this.cart.shipping_address.company = order.shipping_info.company
          this.cart.shipping_address.street1 = order.shipping_info.street1
          this.cart.shipping_address.street2 = order.shipping_info.street2
          this.cart.shipping_address.city = order.shipping_info.city
          this.cart.shipping_address.state = order.shipping_info.state
          this.cart.shipping_address.zip = order.shipping_info.zip
          this.cart.shipping_address.country = order.shipping_info.country
          this.cart.shipping_address.email = order.shipping_info.email
          this.cart.shipping_address.phone = order.shipping_info.phone
        }

        if (order.billing_info) {
          if (!this.cart.billing_address) this.cart.billing_address = {}
          this.cart.billing_address.first_name = order.billing_info.first_name
          this.cart.billing_address.last_name = order.billing_info.last_name
          this.cart.billing_address.company = order.billing_info.company
          this.cart.billing_address.street1 = order.billing_info.street1
          this.cart.billing_address.street2 = order.billing_info.street2
          this.cart.billing_address.city = order.billing_info.city
          this.cart.billing_address.state = order.billing_info.state
          this.cart.billing_address.zip = order.billing_info.zip
          this.cart.billing_address.country = order.billing_info.country
          this.cart.billing_address.email = order.billing_info.email
          this.cart.billing_address.phone = order.billing_info.phone
        }

        if (order.shipping_method) {
          this.cart.shipping_method = order.shipping_method
        }

        if (order.total_shipping) {
          this.cart.total_shipping = order.total_shipping
        }

        api.saveCart(this.cart).then(data => {
          this.$router.push('/checkout?step=3')
        }).catch(error => {
          console.log(error)
        })
      }
    },

    beforeMount () {
      if (this.$route.params.id) {
        api.order(this.$route.params.id).then((data) => {
          this.reorder(data.order)
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// reorder.vue?40178e0e